<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <Header />
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <Navigation />
            </div>
		</div>

        <div class="row mb-5">
            <div id="expertise" class="col-12">
                <Expertise />
            </div>
		</div>

        <div class="row light-gray-bg pb-5 pt-2">
            <div id="services" class="col-12">
                <Services />
            </div>
		</div>

        <div class="row pb-5 pt-3">
            <div id="featuredWork" class="col-12">
                <Clients />
            </div>
		</div>

        <div id="testimonials" class="row pb-5 pt-4">
            <div class="col-12">
                <Testimonials />
            </div>
		</div>

        <div id="contact" class="row light-gray-bg pb-5">
            <div class="col-12">
                <Contact />
            </div>
		</div>


        <div class="row">
            <div class="col-12">
                <Footer />
            </div>
		</div>
        
    </div>
</template>

<script>
    import Header from '../components/Header';
    import Expertise from '../components/Expertise';
    import Services from '../components/Services';
    import Clients from '../components/Clients';
    import Testimonials from '../components/Testimonials';
    import Contact from '../components/Contact';

    import Footer from '../components/Footer';

    export default {
        name: 'Home',
        components: {
            Header,
            Expertise,
            Services,
            Clients,
            Testimonials,
            Contact,
            Footer
        }
    }
</script>